module.exports = __webpack_public_path__ + "static/media/wests-tigers-silhouette.cabc48f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/wests-tigers-silhouette.svg
// module id = 1340
// module chunks = 0